<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Distinta contanti</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    aria-label="Chiudi"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <span class="label-medium-emphasized">Dettaglio banconote e monete per taglio</span>

  @for (row of banknoteRows; track row.importoTaglio) {
    <div class="input-row">
      <div class="amount-column">
        <span class="body-medium">Da</span>
        <span class="body-medium-emphasized">{{ formatAmount(row.importoTaglio) }}</span>
      </div>

      <div class="quantity-column">
        <div class="quantity-input">
          <span class="body-medium">Q.ta</span>
          <mat-form-field class="quantity-field" appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              type="number"
              min="0"
              step="1"
              [attr.aria-label]="'Quantità banconote da ' + row.importoTaglio + ' euro'"
              [(ngModel)]="row.quantita"
            />
          </mat-form-field>
        </div>

        <div class="total-column">
          <span class="body-medium">Importo</span>
          <mat-form-field class="total-field" appearance="outline" subscriptSizing="dynamic">
            <input matInput [value]="formatAmount(getRowTotal(row))" aria-label="Importo" readonly />
          </mat-form-field>
        </div>
      </div>
    </div>
  }

  <div class="input-row">
    <div class="amount-column">
      <span class="body-medium-emphasized">Monete</span>
    </div>

    <div class="quantity-column">
      <div class="total-column">
        <span class="body-medium">Importo</span>
        <mat-form-field class="total-field" appearance="outline" subscriptSizing="dynamic">
          <span matTextPrefix>€&nbsp;</span>
          <input
            matInput
            type="number"
            min="0"
            step="0.01"
            aria-label="Importo monete"
            [(ngModel)]="coinAmount"
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <span class="label-medium-emphasized">
    Totale calcolato: {{ formatAmount(calculatedTotal) }}
  </span>
</mat-dialog-content>

<mat-dialog-actions class="cash-actions">
  <button matButton="outlined" mat-dialog-close type="button">Annulla</button>
  <button matButton="filled" type="button" [mat-dialog-close]="result">Conferma importo</button>
</mat-dialog-actions>
